
import { Component, inject } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import { AsyncPipe } from '@angular/common';
import type { ColDef } from 'ag-grid-community'; // Column Definition Type Interface
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'; 
import { IMeasure } from '../../models/measures.model';
import { MeasuresTableActionsComponent } from '../cell-components/measures-table-actions/measures-table-actions.component';
import { MeasureTypesComponent } from '@components/cell-components/measure-types/measure-types.component';
import { Store } from '@ngrx/store';
import * as fromMeasures from '@store/selectors/measures/measures.selectors';
import { IDropdown } from '@models/dropdown.model';


// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

@Component({
  selector: 'app-measures-table',
  standalone: true,
  imports: [AgGridAngular, AsyncPipe],
  templateUrl: './measures-table.component.html',
  styleUrl: './measures-table.component.css'
})

export class MeasuresTableComponent {

  private readonly store = inject(Store);

  pagination = true;
  paginationPageSize  = 10;
  paginationPageSizeSelector = [10,25,50,100];

  measureTableData$ = this.store.select<IMeasure[]>(fromMeasures.selectMeasureTableData);
  typesList$ = this.store.select<IDropdown[]>(fromMeasures.selectMeasureTypeList);
  defaultColDef: ColDef = {
    flex: 1,
    filter: true,
    floatingFilter: true,
  };

  frameWorkComponents = {
    measuresTableActionsComponent: MeasuresTableActionsComponent,
    measureTypesComponent: MeasureTypesComponent
  }


  // Column Definitions: Defines the columns to be displayed.
  colDefs: ColDef[] = [
    { field: "id", headerName:"Measure ID" },
    { field: "title", headerName:"Title" },
    { field: "description", headerName:"Description" },
    { field: "eMeasure_Measure_identifier", headerName:"ECQM" },
    { field: "qpP_identifier", headerName:"QPP" },
    { field: "measureTypeID", headerName:"Type", cellRenderer: 'measureTypesComponent'},
    { field: "highPriority", headerName:"Hight-Priority", filter: false , valueFormatter: p => (p.value ==1)? "True" : "False"},
    { field: "id", headerName: "Actions", cellRenderer: 'measuresTableActionsComponent', sortable:false, filter: false , minWidth: 150 }
  ];

}
